import { TokenIcon } from "@/components/brand/TokenIcon";
import { TOKEN_ASSETS, type ExtendedTokenId } from "@/lib/token-assets";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import { useState } from "react";

export function TokenSelectSheet({
	value,
	options,
	onChange,
	className,
}: {
	value: ExtendedTokenId;
	options: ExtendedTokenId[];
	onChange: (id: ExtendedTokenId) => void;
	className?: string;
}) {
	const [open, setOpen] = useState(false);
	const asset = TOKEN_ASSETS[value];
	const symbol = asset?.symbol ?? value;

	return (
		<div className={cn("relative shrink-0", className)}>
			<button
				type="button"
				onClick={() => setOpen((v) => !v)}
				className="inline-flex max-w-[10.5rem] items-center gap-2 rounded-full border border-border bg-card px-3 py-2.5 text-sm font-semibold shadow-sm hover:border-primary/40"
			>
				<TokenIcon token={value} size="md" plain />
				<span className="min-w-0 truncate">{symbol}</span>
				<ChevronDown className="size-3.5 shrink-0 text-muted-foreground" />
			</button>
			{open && (
				<>
					<button
						type="button"
						className="fixed inset-0 z-40"
						aria-label="Close"
						onClick={() => setOpen(false)}
					/>
					<ul className="absolute right-0 z-50 mt-1 min-w-[11rem] max-w-[14rem] rounded-xl border border-border bg-card p-1 shadow-lift">
						{options.map((id) => {
							const sym = TOKEN_ASSETS[id]?.symbol ?? id;
							return (
								<li key={id}>
									<button
										type="button"
										className={cn(
											"flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-left text-sm hover:bg-muted",
											id === value && "bg-primary/10 text-primary",
										)}
										onClick={() => {
											onChange(id);
											setOpen(false);
										}}
									>
										<TokenIcon token={id} size="md" plain />
										<span className="min-w-0 truncate font-semibold">{sym}</span>
									</button>
								</li>
							);
						})}
					</ul>
				</>
			)}
		</div>
	);
}
